import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const CateRequest = {
  listOrgan: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate/organ`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  listDocumentType: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate/document-type`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  listDocumentStatus: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate/document-status`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
